import { Link, type LinkProps } from "react-router-dom";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { getWhitelabelCustomization } from "common/helpers/utils";

// this link navigates relative to the selected workspaceId id
// i.e: 'home' becomes workspaces/:workspaceId/home

export default function RelativeLink({ to, ...rest }: LinkProps) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  return (
    <Link
      to={
        getWhitelabelCustomization() ? to : `/workspaces/${workspaceId}/${to}`
      }
      {...rest}
    />
  );
}
